export { Pill } from "./Pill";
export type { PillProps, PillVariants, PillSize, PillElement } from "./Pill";
